import axios from "axios";

// ALWAYS use same-origin /api in browser - Emergent K8s ingress routes /api/* to backend
// This works on any domain: preview, production, custom domain (amazwealth.in)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = (() => {
  // In browser: always use current origin + /api (same-origin = no CORS needed)
  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }
  // Fallback for SSR/testing
  return `${BACKEND_URL || "http://localhost:8001"}/api`;
})();

// Token storage
export const authStore = {
  getToken: () => localStorage.getItem("access_token"),
  setToken: (token) => { if (token) localStorage.setItem("access_token", token); },
  clearToken: () => localStorage.removeItem("access_token"),
};

// Axios interceptor to add Authorization header
axios.interceptors.request.use((config) => {
  const token = authStore.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
